import { useEffect, useState } from 'react'

import useFilterStore from '../../../hooks/useFilterStore'

export const useJfsFilterState = () => {
  const {
    sort: appliedSort,
    setSort: setAppliedSort,
    subFilters: appliedSubFilters,
    setSubFilter: setAppliedSubFilters,
  } = useFilterStore((state) => ({
    sort: state?.sort,
    setSort: state?.setSort,
    subFilters: state?.subFilters,
    setSubFilter: state?.setSubFilter,
  }))

  const [localSort, setLocalSort] = useState(appliedSort)
  const [localFilters, setLocalFilters] = useState(appliedSubFilters)

  // Sync local state with applied state
  useEffect(() => {
    setLocalSort(appliedSort)
    setLocalFilters(appliedSubFilters)
  }, [appliedSort, appliedSubFilters])

  const toggleFilter = (filterKey: string, itemKey: string) => {
    setLocalFilters((prev) => {
      const currentFilters = Array.isArray(prev?.[filterKey])
        ? prev[filterKey]
        : []

      const isSelected = currentFilters.includes(itemKey)
      const newFilters = isSelected
        ? currentFilters.filter((key: string) => key !== itemKey)
        : [...currentFilters, itemKey]

      return {
        ...prev,
        [filterKey]: newFilters.length > 0 ? newFilters : undefined,
      }
    })
  }

  const resetAll = () => {
    setLocalSort('')
    setLocalFilters({})
    setAppliedSort('')
    setAppliedSubFilters({})
  }

  const applyFilters = () => {
    setAppliedSort(localSort)
    setAppliedSubFilters(localFilters)
  }

  const resetToApplied = () => {
    setLocalSort(appliedSort)
    setLocalFilters(appliedSubFilters)
  }

  return {
    localSort,
    setLocalSort,
    localFilters,
    toggleFilter,
    resetAll,
    applyFilters,
    resetToApplied,
  }
}
